import React, { useState } from 'react'
import classnames from 'classnames'

import { DarkPrimaryButton } from 'components'
import TicketDetailsModal from './TicketDetailsModal'

const MyTicketButton = props => {
  const { eventData, event, user, className, ...rest } = props
  const [showTicketDetails, setShowTicketDetails] = useState(false)

  return (
    <>
      <DarkPrimaryButton
        className={classnames(className, 'cursor-pointer')}
        onClick={() => setShowTicketDetails(true)}
        {...rest}
      >
        My Ticket
      </DarkPrimaryButton>
      <TicketDetailsModal
        show={showTicketDetails}
        onClose={() => setShowTicketDetails(false)}
        user={user}
        event={event}
      />
    </>
  )
}

export default MyTicketButton
